import React from 'react';
import PropTypes from 'prop-types';
import { NotificationContainer } from 'react-notifications';
import { Box, HStack, VStack } from '@chakra-ui/react';
import { Container, Row, Col } from 'reactstrap';
import 'react-notifications/lib/notifications.css';

const Page = ({ header, description, actions, children, breadCrumbs }) => {
  return (
    <VStack pt={8}>
      <Box p={'32px'} maxW={'1920px'} w="100%">
        {!!actions && (
          <HStack justifyContent={'flex-end'} mb={6}>
            {actions}
          </HStack>
        )}

        {children}
        <div className="text-left">
          <NotificationContainer />
        </div>
      </Box>
    </VStack>
  );
};

Page.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
  breadCrumbs: PropTypes.array,
};

export default Page;



// WEBPACK FOOTER //
// src/components/shared/Page/index.jsx